"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowButton = exports.Direction = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const arrow_right_svg_1 = __importDefault(require("../../assets/icons/arrow-right.svg"));
var Direction;
(function (Direction) {
    Direction["Top"] = "Top";
    Direction["Right"] = "Right";
    Direction["Bottom"] = "Bottom";
    Direction["Left"] = "Left";
})(Direction || (exports.Direction = Direction = {}));
const DISABLE_ANIMATION_CLASSNAME = 'disable-animation';
const ANIMATION_DURATION = 200;
/**
 * Button with arrow icon
 */
function ArrowButton(_a, externalRef) {
    var { direction = Direction.Right } = _a, props = __rest(_a, ["direction"]);
    const internalRef = (0, react_1.useRef)(null);
    const ref = externalRef || internalRef;
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { nodeRef: ref, in: !props.disabled, timeout: {
            appear: 0,
            enter: ANIMATION_DURATION,
            exit: ANIMATION_DURATION,
        }, appear: true, classNames: DISABLE_ANIMATION_CLASSNAME, "data-e2e": 'ArrowButton_CSSTransition', children: (0, jsx_runtime_1.jsx)(Container, Object.assign({ ref: ref }, props, { "data-e2e": 'ArrowButton_Container', children: (0, jsx_runtime_1.jsx)(ArrowIcon, { "$direction": direction, "data-e2e": 'ArrowButton_ArrowIcon' }) })) }));
}
const ArrowButtonWithRef = (0, react_1.forwardRef)(ArrowButton);
exports.ArrowButton = ArrowButtonWithRef;
const Container = styled_components_1.default.button `
  padding: 0;
  margin: 0;
  border: none;
  background: none;

  height: 22px;
  width: 22px;

  flex-shrink: 0;

  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  color: ${({ theme }) => theme.userOnboarding.arrowButton.disabled};

  &.${DISABLE_ANIMATION_CLASSNAME}-enter {
    color: ${({ theme }) => theme.userOnboarding.arrowButton.disabled};
  }

  &.${DISABLE_ANIMATION_CLASSNAME}-enter-active {
    color: ${({ theme }) => theme.userOnboarding.arrowButton.enabled};

    transition: color ${ANIMATION_DURATION}ms ease-in;
  }

  &.${DISABLE_ANIMATION_CLASSNAME}-enter-done {
    color: ${({ theme }) => theme.userOnboarding.arrowButton.enabled};
  }

  &.${DISABLE_ANIMATION_CLASSNAME}-exit {
    color: ${({ theme }) => theme.userOnboarding.arrowButton.enabled};
  }

  &.${DISABLE_ANIMATION_CLASSNAME}-exit-active {
    color: ${({ theme }) => theme.userOnboarding.arrowButton.disabled};

    transition: color ${ANIMATION_DURATION}ms ease-in;
  }

  &.${DISABLE_ANIMATION_CLASSNAME}-exit-done {
    color: ${({ theme }) => theme.userOnboarding.arrowButton.disabled};
  }
`;
const ArrowIcon = (0, styled_components_1.default)(arrow_right_svg_1.default) `
  height: 100%;
  width: 100%;

  ${({ $direction }) => {
    switch ($direction) {
        case Direction.Bottom:
            return (0, styled_components_1.css) `
          transform: rotate(0.25turn);
        `;
        case Direction.Left:
            return (0, styled_components_1.css) `
          transform: rotate(0.5turn);
        `;
        case Direction.Top:
            return (0, styled_components_1.css) `
          transform: rotate(-0.25turn);
        `;
        case Direction.Right:
        default:
            return;
    }
}}
`;
